import { render } from "./DashUserWelcome.vue?vue&type=template&id=d8395d18&scoped=true&ts=true"
import script from "./DashUserWelcome.vue?vue&type=script&lang=ts"
export * from "./DashUserWelcome.vue?vue&type=script&lang=ts"

import "./DashUserWelcome.vue?vue&type=style&index=0&id=d8395d18&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8395d18"]])

export default __exports__